import { useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { universMagasin } from '../../lib/modules';
import { LETTRES_MINIMUM, cherche } from '../../lib/recherche';
import { C } from '../../theme/palette';
import { termesOffre } from '../../lib/terminologie';

/**
 * Recherche globale.
 *
 * Une barre unique plutôt qu'une recherche par écran : on cherche « Dupont »
 * sans savoir d'avance si ce qu'on veut est la fiche client, son devis ou sa
 * facture. Le résultat mène à l'écran qui porte la pièce, et non à la pièce
 * elle-même — les écrans savent déjà retrouver la leur.
 */
export function RecherchePage({
  onNav,
  soc,
  devis,
  factures,
  clients,
  employes,
  chantiers,
  estMixte,
  univers,
  setUnivers,
}) {
  const [q, setQ] = useState('');
  const mag = universMagasin({ soc, estMixte, univers });
  const motPiece = termesOffre(soc, { estMag: mag }).Mot;
  const res = cherche(q, { clients, employes, devis, factures, chantiers, mag, motPiece });
  const assezLong = q.trim().length >= LETTRES_MINIMUM;

  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      back
      onBack={() => onNav('plus')}
      pageTitle="🔍 Rechercher"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <Card style={{ marginBottom: 12 }}>
        <Bar
          icon="🔍"
          title="Recherche globale"
          color={C.navy}
          sub={
            mag
              ? 'Trouve tout : client, employé, offre, facture'
              : 'Trouve tout : client, employé, devis, facture, chantier'
          }
        />
        <div style={{ padding: 13 }}>
          <div style={{ fontSize: 10, color: C.grey, marginBottom: 8, lineHeight: 1.5 }}>
            {mag
              ? 'Écris ou dicte (🎤 du clavier) : un nom de client, un employé, un n° d’offre/facture…'
              : 'Écris ou dicte (🎤 du clavier) : un nom de client, un employé, un n° de devis/facture, un chantier…'}
          </div>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
            placeholder={
              mag ? 'Ex : Dupont · F-2026-011 · offre...' : 'Ex : Dupont · Villa Rolle · devis...'
            }
            style={{
              width: '100%',
              boxSizing: 'border-box',
              border: '2px solid ' + C.navy,
              borderRadius: 10,
              padding: 12,
              fontSize: 14,
            }}
          />
        </div>
      </Card>

      {assezLong ? (
        <Card>
          <Bar
            icon="📋"
            title={res.length + ' résultat' + (res.length > 1 ? 's' : '')}
            color={res.length ? C.green : C.muted}
          />
          <div style={{ padding: 6 }}>
            {res.length === 0 ? (
              <div style={{ textAlign: 'center', color: C.muted, fontSize: 11, padding: 16 }}>
                Rien trouvé pour « {q} ». Essaie un autre mot.
              </div>
            ) : (
              res.map((r, i) => (
                <div
                  key={i}
                  // L'élément touché lui-même, et non sa liste à refouiller.
                  onClick={() => onNav(r.nav, r.ouverture)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '11px 10px',
                    borderBottom: i < res.length - 1 ? '1px solid ' + C.border : 'none',
                    cursor: 'pointer',
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: C.ink }}>{r.nom}</div>
                    <div style={{ fontSize: 9, color: C.muted, marginTop: 2 }}>
                      {r.type}
                      {r.sub ? ' · ' + r.sub : ''}
                    </div>
                  </div>
                  <span style={{ color: C.muted, fontSize: 16, flexShrink: 0 }}>›</span>
                </div>
              ))
            )}
          </div>
        </Card>
      ) : (
        <div style={{ fontSize: 9, color: C.muted, textAlign: 'center', padding: 10 }}>
          Tape au moins {LETTRES_MINIMUM} lettres pour lancer la recherche.
        </div>
      )}
    </Shell>
  );
}
